var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"video-carousel carousel",attrs:{"id":"video"}},[(_vm.videoLink)?[_c('div',{staticClass:"videoLink"},[_c('a',{attrs:{"href":_vm.videoLink,"target":"_blank"}},[_vm._v(_vm._s(_vm.$tr('responses.goToVideo')))])])]:_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }